import moment from 'moment';
import { toCamelCase } from 'case-converter';

import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { AvailableRoomById, StaticRoomById } from '@features/rooms';
import { Rate } from '@features/rates';
import { AvailableRoomSchema, RatesSchema, StaticRoomSchema } from './schemas';
import { AvailableRoom, Rates, RoomAvailabilityParams, StaticRoom } from './types';

export function toStaticRoom(room: StaticRoomById): StaticRoom {
  const camelCaseRoom = toCamelCase(room);
  const { additionalImages, imageUrl } = camelCaseRoom;
  const images = [{ imageUrl }, ...(additionalImages ?? [])].map((img) => ({
    url: img.imageUrl,
  }));

  return StaticRoomSchema.parse({ ...camelCaseRoom, images });
}

export function toCamelCaseAvailableRoom(room: AvailableRoomById): AvailableRoom {
  return AvailableRoomSchema.parse(toCamelCase(room));
}

export function toRoomAvailabilityParams(
  journeyParams: ParsedJourneyParams
): RoomAvailabilityParams {
  const { fromDate, toDate } = journeyParams;
  return {
    ...journeyParams,
    fromDate: fromDate.format('YYYY-MM-DD'),
    toDate: toDate ? toDate.format('YYYY-MM-DD') : moment().add('1', 'days').format('YYYY-MM-DD'),
  };
}

export function toRates(roomRates: Rate[]): Rates {
  return RatesSchema.parse(
    roomRates.map((rate) => ({
      pricePerStay: rate.price,
      rateId: rate.id,
      rateTitle: rate.title,
      rateDescription: rate.description,
      rateTerms: rate.cancellationPolicyText ?? '',
      rateImageUrl: rate.imageUrl,
      roomUpgrade: rate.roomUpgrade,
      available: rate.quantity ?? 0,
    }))
  );
}
